import store from '@/store/index.js'


String.prototype.trim = function () {
    return this.replace(/(^\s*)|(\s*$)/g, "");
}

// 处理htmlcontent
String.prototype.dealHtmlContent = function () {
    let value = this
    value = value.replace(/(\n)/g, "");
    value = value.replace(/(\t)/g, "");
    value = value.replace(/(\r)/g, "");
    value = value.replace(/<\/?[^>]*>/g, "");
    value = value.replace(/\s*/g, "");
    return value
}

// 时间只保留日期
String.prototype.getDate = function () {
    let content = this
    if (content.length < 10) {
        return content
    } else {
        return content.slice(0, 10)
    }
}

// 数组去重
Array.prototype.unique = function () {
    var res = [];
    var json = {};
    for (var i = 0; i < this.length; i++) {
        if (!json[this[i]]) {
            res.push(this[i]);
            json[this[i]] = 1;
        }
    }
    return res;
}

export default {
    // 手机号正则
    isPhonePattern: /^1[3456789]\d{9}$/,
    // 邮箱正则
    isEmailPattern: /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/,
    // QQ号正则
    isQQPattern: /^[1-9]\d{4,10}$/,
    // 身份证号正则
    isNationalNoPattern: /^(\d{18,18}|\d{15,15}|\d{17,17}x)/,
    // 正实数正则
    isPositiveNumber: /^[+]?([1-9][0-9]*(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$/,
    // 实数正则
    isNumberPattern: /^-?\d+\.?\d*$/,
    // 正整数正则
    isPositiveIntNumber: /^[1-9]\d*$/,
    //大于等于0
    isPositiveZeroNumber: /^[+]?([0-9][0-9]*(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$/,

    //手机号码
    isPhone: (str) => {
        const phone = str.substring(0, 3) === '+86' ? str.substring(3) : str //判定区号
        const reg = /^1[3456789]\d{9}$/;
        return reg.test(phone);
    },

    isEmpty(obj) {
        if (typeof obj == "undefined" || obj == null) {
            return true;
        } else if (typeof obj === 'string' && obj.trim() === '') {
            return true
        } else {

            return false;
        }
    },

    // 下载文件
    downloadFile(url, name) {
        var a = document.createElement("a");
        a.target = "_blank"
        a.href = url;
        a.setAttribute("download", name || url || '');
        var evt = document.createEvent("MouseEvents");
        evt.initEvent("click", true, true);
        a.dispatchEvent(evt);
    },

    checkMenuOprate(menu) {
        if(store.state.userInfo && JSON.parse(store.state.userInfo)) {
            let userInfo = JSON.parse(store.state.userInfo)
            let menuConfig = JSON.parse(userInfo.menuConfig)
            for(let i = 0;i < menuConfig.length; i++) {
                let item = menuConfig[i]
                if(item.menuItem ==  menu) {
                    return item.allowAction
                }
            }
            return null
        }
    },

}
